import styled from 'styled-components'
import Box from 'components/shared/Box'

export const ZonesModalBackButtonWrapper = styled(Box)`
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
    padding: 16px;
    background: ${({ theme }) => theme.colors.grayscale_0};
    box-shadow: 0 4px 35px 0 rgba(32, 0, 139, 0.05);
`
